<!--This component represents the root page content. For angularjs pages, the ng-content lets us insert ngjs
    content externally (usually a ui-view) provided by a razor page--this component has to live in a _layout
    razor partial. In contrast, Angular pages will use the router-outlet to present content in a SPA configuration
    going forward.
-->
<dgx-bulk-icon-registry>
  <ng-content></ng-content>
</dgx-bulk-icon-registry>
<router-outlet></router-outlet>
